import React, { useState } from "react";
import MainModal from "components/ModalMain";
import Button from "components/Button";
import Input from "components/Input";
import ModalChangeEmailAddressConfirmation from "screens/ModalConfirmationRequired";
import ModalGeneralFailed from "screens/ModalGeneralFailed";
import { useMutation } from "@apollo/client";
import { UPDATE_PIN_BY_USER_ID } from "graphql/service";
import { Head, Container, Footer } from "./styles";

const ModalChangePIN = ({
  hidden,
  buttonStyle,
  userId
}) => {

  const [isOpen, setIsOpen] = useState(false);
  const [confirmationIsOpen, setConfirmationIsOpen] = useState(false);
  const [failedIsOpen, setFailedIsOpen] = useState(false);
  const [PIN, setPIN] = useState("");
  const [PINError, setPINError] = useState(false);

  const [updatePINByUserId, { loading }] = useMutation(UPDATE_PIN_BY_USER_ID, {
    onCompleted: () => {
      setIsOpen(false);
      setFailedIsOpen(false);
      setConfirmationIsOpen(true);
      setPIN("");
    },
    onError: () => {
      setIsOpen(false);
      setFailedIsOpen(true);
    }
  });

  const handleChangePIN = () => {
    if (loading) return;
    if (PIN.trim() === "" || PIN.length !== 6) {
      setPINError(true);
      return;
    }

    updatePINByUserId({
      variables: {
        input: {
          userId,
          input: {
            PIN
          }
        },
      },
    })
  };

  return (
    <>
      <MainModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        className="modal-success"
        buttonLabel="Change PIN"
        buttonStyle={buttonStyle}
        hidden={hidden}
        additionalstyle={`
          max-width: 500px;
          .modal-content{
            .close {
              z-index: 200;
            }          
            .modal-body {
              height: 100%;
              padding: 24px;
            }
          }
          top: 139px;
        `}
      >
        <Head>Enter Current PIN</Head>
        <Container>
          <Input
            title="PIN"
            required
            error={PINError}
            errorMessage="Please enter a valid PIN"
            value={PIN}
            onChange={(e) => {
              setPIN(e.target.value);
              setPINError(false);
            }}
            additionalstyle={`
            width: 100%;
          `}
          />
        </Container>
        <Footer>
          <Button
            success
            additionalstyle={`
              width: 97px;
            `}
            onClick={handleChangePIN}
            data-loading={loading}
          >
            {loading ? null : "Continue"}
          </Button>
        </Footer>
      </MainModal>

      <ModalGeneralFailed
        isOpen={failedIsOpen}
        setIsOpen={setFailedIsOpen}
        loading={loading}
        retryFunction={handleChangePIN}
        type="changeEmail"
      />
    </>
  );
};

export default ModalChangePIN;